import { ListItemIcon, ListItemText } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { netsuiteSyncWizardSelectors } from '@vy/app-selectors';
import React from 'react';
import { useQueryClient } from 'react-query';
import { useDialog } from '../../../../../hooks/use-dialog';
import { prefetchContractProductsOverviews } from '../../../../../hooks/requests/use-contract-products-overviews';
import { prefetchNetSuiteUsers } from '../../../../../hooks/requests/integrations/net-suite/use-net-suite-users';
import { NetSuiteSyncWizard } from './NetSuiteSyncWizard';
import { VyIcon } from '@vy/ui-design-system';
import { isNotEmptyString } from '@vy/utils';

type MenuItemNetSuiteExportContractProps = {
  contractId: string;
  customerId: string;
  planId: string;
  disabled?: boolean;
  isSynced: boolean;
  customerErpId?: string;
};

export const MenuItemNetSuiteExportContract: React.FC<MenuItemNetSuiteExportContractProps> = ({
  contractId,
  customerId,
  disabled,
  isSynced,
  customerErpId,
}) => {
  const queryClient = useQueryClient();
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  const handleClick = () => {
    void prefetchContractProductsOverviews(contractId, queryClient);

    if (isNotEmptyString(customerErpId)) {
      void prefetchNetSuiteUsers(customerErpId, queryClient);
    }

    handleOpen();
  };

  return (
    <>
      <MenuItem
        disabled={disabled}
        onClick={handleClick}
        data-vy={netsuiteSyncWizardSelectors.openMenuItem}
      >
        <ListItemIcon>
          <VyIcon icon="Synchronize" strokeOpacity={1} />
        </ListItemIcon>
        <ListItemText>Sync ERP</ListItemText>
      </MenuItem>

      {isDialogOpen && (
        <NetSuiteSyncWizard
          isSynced={isSynced}
          open={isDialogOpen}
          onClose={handleClose}
          contractId={contractId}
          customerId={customerId}
          customerErpId={customerErpId}
        />
      )}
    </>
  );
};
